<template>
  <div>
    <!-- NUEVO: Mensaje para Basic Agents -->
    <div v-if="isBasicAgent && upgradePrompt" class="p-4">
      <div class="bg-gradient-to-r from-gray-50 to-blue-50 border border-gray-200 rounded-xl p-4">
        <div class="flex items-start">
          
          <div class="flex-1">
            
            <p class="p-1 text-xs text-gray-600">
              {{ $t('agentDashboard.summary.upgradePrompt') }}
            </p>
            <div class="mt-3">
              <button
                @click="openUpgradeModal"
                class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 rounded-full shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                
                {{ $t('agentDashboard.summary.upgradeButton') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumen de métricas -->
    <div class="p-4">
      <div class="bg-white rounded-xl shadow-sm p-4 border border-gray-200">
      <h3 class="text-sm font-semibold text-gray-900 mb-3 flex items-center">
        {{ $t('agentDashboard.summary.generalSummary') }}
      </h3>
      <div class="grid grid-cols-2 gap-2">
        <div >
          <div class="text-sm font-bold text-blue-600">{{ totalContracts }}</div>
          <div class="text-xs text-blue-600 font-medium">{{ $t('agentDashboard.summary.stats.properties') }}</div>
        </div>
        <div >
          <div class="text-sm font-bold text-green-600">{{ totalColivings }}</div>
          <div class="text-xs text-green-600 font-medium">{{ $t('agentDashboard.summary.stats.colivings') }}</div>
        </div>
        <div >
          <div class="text-sm font-bold text-cyan-600">{{ preAssignedUsers }}</div>
          <div class="text-xs text-cyan-600 font-medium">{{ $t('agentDashboard.summary.stats.inProgress') }}</div>
        </div>
        <div >
          <div class="text-sm font-bold text-purple-600">{{ totalInterested }}</div>
          <div class="text-xs text-purple-600 font-medium">{{ $t('agentDashboard.summary.stats.interested') }}</div>
        </div>
        </div>
      </div>
    </div>

    <!-- OCULTO: Lista de propiedades tradicionales y destacadas deshabilitadas (código eliminado) -->

    <!-- Colivings destacados -->
    <ColivingsDestacados
      :highlighted-colivings="highlightedColivings"
      @go-to-coliving="$emit('go-to-coliving', $event)"
    />

    <!-- Verificaciones pendientes -->
    <div class="p-4 border-b border-gray-200" v-if="pendingVerificationsList.length > 0 && !isBasicAgent">
      <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">{{ $t('agentDashboard.summary.pendingVerifications.title') }}</h4>
      <div class="space-y-2">
        <div
          v-for="client in pendingVerificationsList"
          :key="client.id"
          class="bg-yellow-50 rounded-lg p-2 border border-yellow-200 hover:bg-yellow-100 transition-all duration-200 cursor-pointer"
          @click="$emit('go-to-verifications')"
        >
          <div class="flex items-center justify-between">
            <div>
              <h5 class="text-xs font-medium text-gray-900">{{ client.fullName }}</h5>
              <p class="text-xs text-gray-600">{{ client.dni }}</p>
            </div>
            <div class="text-xs text-yellow-700 font-medium">
              {{ $t('agentDashboard.summary.pendingVerifications.pending') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Eventos recientes detallados -->
    <DetailedEvents
      :detailed-recent-events="detailedRecentEvents"
      :dismissed-events-count="dismissedEventsCount"
      :user-verification-data="userVerificationData"
      @clear-dismissed-events="$emit('clear-dismissed-events')"
      @dismiss-event="$emit('dismiss-event', $event)"
      @go-to-activity="$emit('go-to-activity')"
      @view-coliving-application="handleViewColivingApplication"
    />

    <!-- Actividad reciente -->
    <div class="p-4 border-b border-gray-200" v-if="recentEvents.length > 0">
      <div class="bg-white rounded-xl shadow-sm p-4 border border-gray-200">
        <div class="flex items-start mb-4">
          <div class="flex-shrink-0 w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center mr-3">
            <BoltIcon class="w-5 h-5 text-yellow-600" />
                </div>
          <div class="grow">
            <h3 class="text-md font-semibold text-gray-800">{{ $t('agentDashboard.summary.recentActivity.title') }}</h3>
            <p class="text-sm text-gray-500">{{ $t('agentDashboard.summary.recentActivity.subtitle') }}</p>
                </div>
              </div>
              
        <div class="space-y-2 mb-4">
        <div
          v-for="event in recentEvents.slice(0, 5)"
          :key="event.id"
          class="flex items-start gap-2 p-2 bg-gray-50 rounded-lg border border-gray-200 group"
        >
          <div 
            :class="getEventIconClass(event.type)"
            class="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-2.5 w-2.5" viewBox="0 0 20 20" fill="currentColor">
              <!-- Iconos de actividad reciente (más pequeños) -->
              <path v-if="event.type === 'contract'" fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              <path v-else-if="event.type === 'signed'" fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              <path v-else-if="event.type === 'interest'" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
              <path v-else-if="event.type === 'assigned'" d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
              <path v-else-if="event.type === 'verification'" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              <path v-else fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-xs font-medium text-gray-900">{{ event.title }}</p>
            <p class="text-xs text-gray-500 truncate">{{ event.description }}</p>
            <p class="text-xs text-gray-400 mt-0.5">{{ formatEventDate(event.date) }}</p>
          </div>
          <button
            @click="$emit('dismiss-event', event.id)"
            class="flex-shrink-0 w-4 h-4 rounded-full bg-gray-200 hover:bg-red-100 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-200 hover:scale-110"
            title="Eliminar evento"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-2.5 w-2.5 text-gray-500 hover:text-red-600" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
            </button>
          </div>
        </div>

        <button 
          @click="$emit('go-to-activity')" 
          class="w-full py-2 px-4 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
        >
          Ver toda la actividad
          </button>
        </div>
      </div>
    </div>

    <!-- Componente Modal de Actualización a PRO -->
    <UpgradeToProModal 
      :is-visible="showUpgradeModal" 
      @close="closeUpgradeModal"
      @success="onUpgradeSuccess"
    />

</template>

<script setup>
import { BanknotesIcon, DocumentTextIcon, ShieldCheckIcon, TrophyIcon, BuildingOffice2Icon, BellIcon, BoltIcon } from '@heroicons/vue/24/solid'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebase'
import { getAuth } from 'firebase/auth'
import { 
  isCurrentUserBasicAgent, 
  getUpgradePromptInfo, 
  getRoleBadgeClass,
  getRoleDisplayText 
} from '../../utils/agentRoleUtils'
import ColivingsDestacados from './ColivingsDestacados.vue'
import DetailedEvents from './DetailedEvents.vue'
import UpgradeToProModal from './UpgradeToProModal.vue'

const router = useRouter()
const { t } = useI18n()
const auth = getAuth()

// Datos en tiempo real de Firestore
const realTimeContracts = ref(0)
const realTimeColivings = ref(0)
const realTimePreAssignedUsers = ref(0)
const realTimeInterested = ref(0)

// Referencias a los listeners de Firestore
const unsubscribeListeners = ref([])

// NUEVO: Estados para Basic Agents
const isBasicAgent = ref(false)
const upgradePrompt = ref(null)

// NUEVO: Estados para el modal de actualización a PRO
const showUpgradeModal = ref(false)

// Propiedades computadas que combinan los datos en tiempo real con los props
const totalContracts = computed(() => {
  return realTimeContracts.value > 0 ? realTimeContracts.value : props.totalContracts
})

const totalColivings = computed(() => {
  return realTimeColivings.value > 0 ? realTimeColivings.value : props.totalColivings
})

const preAssignedUsers = computed(() => {
  return realTimePreAssignedUsers.value > 0 ? realTimePreAssignedUsers.value : props.preAssignedUsers
})

const totalInterested = computed(() => {
  return realTimeInterested.value > 0 ? realTimeInterested.value : props.totalInterested
})

const props = defineProps({
  totalContracts: {
    type: Number,
    default: 0
  },
  totalColivings: {
    type: Number,
    default: 0
  },
  preAssignedUsers: {
    type: Number,
    default: 0
  },
  totalInterested: {
    type: Number,
    default: 0
  },
  // OCULTO: Props de contratos tradicionales deshabilitados
  // contractsWithStats: {
  //   type: Array,
  //   default: () => []
  // },
  // highlightedContracts: {
  //   type: Array,
  //   default: () => []
  // },
  highlightedColivings: {
    type: Array,
    default: () => []
  },
  pendingVerificationsList: {
    type: Array,
    default: () => []
  },
  detailedRecentEvents: {
    type: Array,
    default: () => []
  },
  recentEvents: {
    type: Array,
    default: () => []
  },
  dismissedEventsCount: {
    type: Number,
    default: 0
  },
  clients: {
    type: Array,
    default: () => []
  },
  userVerificationData: {
    type: Map,
    default: () => new Map()
  }
})

// OCULTO: Eventos de contratos tradicionales deshabilitados
const emit = defineEmits([
  // 'select-contract',
  // 'view-candidates', 
  // 'go-to-contract',
  'go-to-coliving',
  'go-to-verifications',
  'dismiss-event',
  'clear-dismissed-events',
  'go-to-activity'
])

// Función para inicializar los listeners de Firestore en tiempo real
const initializeFirestoreListeners = async () => {
  if (!auth.currentUser) return
  
  try {
    const agentId = auth.currentUser.uid
    
    // 1. Listener para contratos
    const contractsQuery = query(
      collection(db, 'contracts'),
      where('agentId', '==', agentId)
    )
    
    const contractsUnsubscribe = onSnapshot(contractsQuery, (snapshot) => {
      realTimeContracts.value = snapshot.size
    }, (error) => {
      console.error('Error en listener de contratos:', error)
    })
    
    unsubscribeListeners.value.push(contractsUnsubscribe)
    
    // 2. Listener para colivings
    const colivingsQuery = query(
      collection(db, 'colivings'),
      where('agentId', '==', agentId)
    )
    
    const colivingsUnsubscribe = onSnapshot(colivingsQuery, (snapshot) => {
      realTimeColivings.value = snapshot.size
      
      // Calcular usuarios pre-asignados y total de interesados
      let preAssigned = 0
      let interested = 0
      
      snapshot.forEach(doc => {
        const coliving = doc.data()
        if (coliving.applications && Array.isArray(coliving.applications)) {
          const inProgressStatuses = ['pre_approved', 'owner_signed', 'applicant_signed', 'contract_signed', 'payment_completed']
          preAssigned += coliving.applications.filter(app => 
            inProgressStatuses.includes(app.status)
          ).length
          
          // Contar solicitudes pendientes
          interested += coliving.pendingApplications || 0
        }
      })
      
      realTimePreAssignedUsers.value = preAssigned
      
      // Obtener los IDs de los colivings del agente
      const colivingIds = snapshot.docs.map(doc => doc.id)
      
      // Si no hay colivings, no necesitamos configurar listeners para aplicaciones
      if (colivingIds.length === 0) {
        realTimeInterested.value = interested
        return
      }
      
      // Limpiar listeners anteriores de aplicaciones si existen
      if (window.applicationListeners) {
        window.applicationListeners.forEach(unsubscribe => {
          if (typeof unsubscribe === 'function') {
            unsubscribe()
          }
        })
      }
      
      // Reiniciar el array de listeners
      window.applicationListeners = []
      
      // Configurar un listener para cada coliving del agente
      // Esto es compatible con las reglas de seguridad que permiten filtrar por colivingId
      
      // Objeto para almacenar el recuento de aplicaciones por coliving
      const pendingApplicationsCounts = {}
      
      // Función para actualizar el contador total
      const updateTotalInterested = () => {
        // Sumar todas las aplicaciones pendientes
        const totalPendingApps = Object.values(pendingApplicationsCounts).reduce((sum, count) => sum + count, 0)
        // Actualizar el contador global
        realTimeInterested.value = interested + totalPendingApps
      }
      
      // Para cada coliving, configurar un listener
      colivingIds.forEach(colivingId => {
        // Inicializar contador para este coliving
        pendingApplicationsCounts[colivingId] = 0
        
        const colivingApplicationsQuery = query(
          collection(db, 'colivingApplications'),
          where('colivingId', '==', colivingId),
          where('status', '==', 'submitted') // Solo contar las solicitudes pendientes
        )
        
        const unsubscribe = onSnapshot(colivingApplicationsQuery, (appSnapshot) => {
          // Actualizar el contador para este coliving específico
          pendingApplicationsCounts[colivingId] = appSnapshot.size
          
          // Actualizar el contador total
          updateTotalInterested()
        }, (error) => {
          console.error(`Error en listener de aplicaciones para coliving ${colivingId}:`, error)
          // En caso de error, asumimos 0 aplicaciones para este coliving
          pendingApplicationsCounts[colivingId] = 0
          updateTotalInterested()
        })
        
        // Guardar referencia al unsubscribe
        window.applicationListeners.push(unsubscribe)
        unsubscribeListeners.value.push(unsubscribe)
      })
      
    }, (error) => {
      console.error('Error en listener de colivings:', error)
    })
    
    unsubscribeListeners.value.push(colivingsUnsubscribe)
    
  } catch (error) {
    console.error('Error al inicializar listeners de Firestore:', error)
  }
}

// Limpiar los listeners cuando el componente se desmonta
onUnmounted(() => {
  // Limpiar los listeners principales
  unsubscribeListeners.value.forEach(unsubscribe => {
    if (typeof unsubscribe === 'function') {
      unsubscribe()
    }
  })
  unsubscribeListeners.value = []
  
  // Limpiar los listeners de aplicaciones
  if (window.applicationListeners) {
    window.applicationListeners.forEach(unsubscribe => {
      if (typeof unsubscribe === 'function') {
        unsubscribe()
      }
    })
    window.applicationListeners = []
  }
})

// Función para verificar tipo de agente
const checkAgentType = async () => {
  try {
    isBasicAgent.value = await isCurrentUserBasicAgent()
    
    if (isBasicAgent.value) {
      upgradePrompt.value = await getUpgradePromptInfo('Dashboard Completo')
    }
  } catch (error) {
    console.error('[AgentResumenNav] Error verificando tipo de agente:', error)
  }
}

// Inicializar los listeners cuando el componente se monta
onMounted(async () => {
  // Inicializar el array de listeners de aplicaciones
  window.applicationListeners = []
  
  // NUEVO: Verificar tipo de agente
  await checkAgentType()
  
  initializeFirestoreListeners()
  
  // Reiniciar los listeners si cambia el usuario autenticado
  const unsubscribeAuth = auth.onAuthStateChanged(async user => {
    if (user) {
      // Limpiar listeners existentes primero
      unsubscribeListeners.value.forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe()
        }
      })
      unsubscribeListeners.value = []
      
      // Limpiar también los listeners de aplicaciones
      if (window.applicationListeners) {
        window.applicationListeners.forEach(unsubscribe => {
          if (typeof unsubscribe === 'function') {
            unsubscribe()
          }
        })
        window.applicationListeners = []
      }
      
      // NUEVO: Verificar tipo de agente después del cambio de autenticación
      await checkAgentType()
      
      // Inicializar nuevos listeners
      initializeFirestoreListeners()
    }
  })
  
  // Añadir a la lista de listeners para limpieza
  unsubscribeListeners.value.push(unsubscribeAuth)
})

// OCULTO: Funciones de contratos tradicionales deshabilitadas (no se usan)
// const getContractStatusClass = (contract) => {
//   if (contract.assignedApplicant) {
//     return 'bg-blue-100 text-blue-800'
//   } else if (contract.interestedApplicants?.length > 0) {
//     return 'bg-yellow-100 text-yellow-800'
//   } else {
//     return 'bg-gray-100 text-gray-800'
//   }
// }

// const getContractStatusLabel = (contract) => {
//   if (contract.assignedApplicant) {
//     return 'Asignado'
//   } else if (contract.interestedApplicants?.length > 0) {
//     return 'Con interés'
//   } else {
//     return 'Activo'
//   }
// }

// const getContractStatusKey = (contract) => {
//   if (contract.assignedApplicant) {
//     return 'assigned'
//   } else if (contract.interestedApplicants?.length > 0) {
//     return 'withInterest'
//   } else {
//     return 'active'
//   }
// }

const formatCurrency = (amount) => {
  if (!amount) return ''
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  }).format(amount)
}

const getClientName = (clientId) => {
  if (!clientId) return 'Cliente no encontrado'
  const client = props.clients.find(c => c.id === clientId || c.firebaseAuthUid === clientId)
  return client ? client.fullName : 'Cliente no encontrado'
}

const getColivingClientName = (coliving) => {
  if (coliving.agentIsOwner) {
    return 'Tú (Agente)'
  }
  return getClientName(coliving.clientId)
}

const getOccupiedRoomsCount = (coliving) => {
  if (!coliving.rooms || !Array.isArray(coliving.rooms)) {
    return 0
  }
  return coliving.rooms.filter(room => room.status === 'ocupada').length
}

const getPreAssignedRoomsCount = (coliving) => {
  if (!coliving.applications || !Array.isArray(coliving.applications)) {
    return 0
  }
  const preAssignedStatuses = ['pre_approved', 'owner_signed', 'applicant_signed', 'contract_signed', 'payment_completed'];
  return coliving.applications.filter(app => 
    preAssignedStatuses.includes(app.status)
  ).length
}

const getEventIconClass = (eventType) => {
  const classes = {
    // Eventos de contratos tradicionales
    contract: 'bg-green-100 text-green-600',
    signed: 'bg-green-100 text-green-600',
    assigned: 'bg-blue-100 text-blue-600',
    interest: 'bg-blue-100 text-blue-600',
    
    // Eventos de colivings generales
    coliving: 'bg-purple-100 text-purple-600',
    
    // Eventos específicos de aplicaciones de colivings
    coliving_application: 'bg-indigo-100 text-indigo-600',
    coliving_pre_approved: 'bg-cyan-100 text-cyan-600',
    coliving_signed: 'bg-green-100 text-green-600',
    coliving_payment: 'bg-emerald-100 text-emerald-600',
    coliving_assignment: 'bg-teal-100 text-teal-600',
    coliving_rejected: 'bg-red-100 text-red-600',
    coliving_terminated: 'bg-gray-100 text-gray-600',
    coliving_application_retired: 'bg-orange-100 text-orange-600',
    
    // Otros eventos
    verification: 'bg-yellow-100 text-yellow-600',
    default: 'bg-gray-100 text-gray-600'
  }
  return classes[eventType] || classes.default
}

const formatEventDate = (date) => {
  if (!date) return ''
  
  try {
    const dateObj = new Date(date)
    if (isNaN(dateObj.getTime())) {
      return ''
    }
    
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    }).format(dateObj)
  } catch (error) {
    console.warn('Error al formatear fecha:', date, error)
    return ''
  }
}

// NUEVAS FUNCIONES para solicitudes de coliving

// Función para obtener el título del evento unificado
const getEventTitle = (event) => {
  if (!event || !event.applicationData) return event.title || 'Evento';
  
  const status = event.applicationData.status;
  const colivingTitle = event.applicationData.colivingTitle || event.title || 'Coliving';
  
  const titleMap = {
    'submitted': `Nueva solicitud - ${colivingTitle}`,
    'pre_approved': `Solicitud pre-aprobada - ${colivingTitle}`,
    'owner_signed': `Contrato para firmar - ${colivingTitle}`,
    'applicant_signed': `Contrato para firmar - ${colivingTitle}`,
    'contract_signed': `Contrato firmado - ${colivingTitle}`,
    'payment_completed': `Pago completado - ${colivingTitle}`,
    'room_assigned': `Asignación confirmada - ${colivingTitle}`
  };
  
  return titleMap[status] || event.title;
};

// Función para obtener el texto de estado/siguiente paso
const getStatusInfoText = (applicationData) => {
  if (!applicationData) return '';
  const applicantName = applicationData.applicantName || t('common.theTenant');
  const status = applicationData.status;
  
  const infoMap = {
    'submitted': 'Revisa la solicitud para pre-aprobarla',
    'pre_approved': `${applicantName} debe revisar y firmar el contrato`,
    'owner_signed': `Esperando firma de ${applicantName}`,
    'applicant_signed': 'Falta tu firma para completar el contrato',
    'contract_signed': `${applicantName} debe realizar el primer pago`,
    'payment_completed': 'Pago completado, falta confirmar la asignación final',
    'room_assigned': `✅ ${applicantName} tiene habitación confirmada`
  };
  
  return infoMap[status] || t('common.reviewStatus');
};

// Función para obtener la clase CSS del texto de estado
const getStatusInfoClass = (status) => {
  const classMap = {
    'submitted': 'text-blue-800',
    'pre_approved': 'text-blue-800',
    'owner_signed': 'text-cyan-800',
    'applicant_signed': 'text-orange-800',
    'contract_signed': 'text-purple-800',
    'payment_completed': 'text-emerald-800',
    'room_assigned': 'text-green-800 font-bold'
  };
  return classMap[status] || 'text-gray-800';
};

// Función para obtener estado de verificación del usuario
const getUserVerificationStatus = (userId) => {
  if (!userId || !props.userVerificationData) {
    return {
      verified: false,
      hasDocuments: false,
      hasGuarantor: false
    }
  }
  
  return props.userVerificationData.get(userId) || {
    verified: false,
    hasDocuments: false,
    hasGuarantor: false
  }
}

// Función para formatear el motivo de estancia
const getStayReasonText = (stayReason) => {
  const reasonMap = {
    'work': 'Trabajo',
    'study': 'Estudio', 
    'leisure': 'Ocio',
    'other': 'Otro'
  }
  return reasonMap[stayReason] || stayReason || t('common.notSpecified')
}

// Función para formatear fechas de aplicación
const formatApplicationDate = (date) => {
  if (!date) return t('common.dateNotSpecified')
  
  try {
    const dateObj = date.toDate ? date.toDate() : new Date(date)
    if (isNaN(dateObj.getTime())) {
      return t('common.invalidDate')
    }
    
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).format(dateObj)
  } catch (error) {
    console.warn('Error al formatear fecha de aplicación:', date, error)
    return t('common.invalidDate')
  }
}

// Función para manejar la acción rápida de ver solicitud de coliving
const handleViewColivingApplication = (applicationData) => {
  if (!applicationData || !applicationData.colivingId) {
    console.warn('Datos de aplicación incompletos:', applicationData)
    return
  }
  
  // Navegar a la página de gestión de colivings con parámetros para abrir el modal específico
  router.push({
    path: '/agent-dashboard/colivings',
    query: {
      openColiving: applicationData.colivingId,
      applicationId: applicationData.id,
      applicantId: applicationData.applicantId
    }
  })
}

// NUEVAS FUNCIONES para el modal de actualización a PRO
const openUpgradeModal = () => {
  showUpgradeModal.value = true
}

const closeUpgradeModal = () => {
  showUpgradeModal.value = false
}

const onUpgradeSuccess = () => {
  // Función llamada cuando el modal envía exitosamente la solicitud
  // Aquí podríamos actualizar algún estado si fuera necesario
}

// NUEVO: Exponer la función para abrir el modal
defineExpose({
  openUpgradeModal
})
</script> 